import applySearchParams from "libs/applySearchParams";
import {RestRequestBLOB, RestRequestDELETE, RestRequestGET, RestRequestPOST} from "libs/RestRequest";
import Endpoints from "constants/Endpoints";
import reduxStore from "redux/store";
import {clearResource, setResource, setSaveStatusClosed, setSaveStatusDeleted, setSaveStatusError, setSaveStatusLoading} from "redux/actions";

const AUDIT_LIST_RESOURCE = 'auditList';
const AUDIT_TASK_RESOURCE = 'auditTask';
const AUDIT_TASK_HISTORY_RESOURCE = 'auditTaskHistory';

const get = async (taskId, admin) => {
    const resp = await RestRequestGET(admin ? Endpoints.AUDIT_ADMIN(taskId) : Endpoints.AUDIT(taskId));
    reduxStore.dispatch(
        setResource(AUDIT_TASK_RESOURCE, resp)
    )
}

const getTasks = async (adminMode, page = 1, pageSize = 10, filters = {}, sort = {}) => {

    const {
        column,
        direction
    } = sort

    let params = {
        'page': page,
        'pageSize': pageSize
    }
    params = applySearchParams(filters, params);

    if (column) {
        params['sort[0].column'] = column
        params['sort[0].direction'] = direction.toUpperCase()
    }

    try {
        const res = await RestRequestGET(adminMode ? Endpoints.AUDIT_LIST_ADMIN : Endpoints.AUDIT_LIST, {
            params
        });

        reduxStore.dispatch(
            setResource(AUDIT_LIST_RESOURCE, res)
        )

        return res;
    } catch (error) {
    }
}

const deleteTask = async (taskId) => {
    reduxStore.dispatch(setSaveStatusLoading());
    try {
        await RestRequestDELETE(Endpoints.AUDIT_ADMIN(taskId));
        reduxStore.dispatch(setSaveStatusDeleted());
    } catch (error) {
        reduxStore.dispatch(setSaveStatusError());
    }
}

const cloneTask = async (taskId) => {
    reduxStore.dispatch(setSaveStatusLoading());
    try {
        const r = await RestRequestPOST(Endpoints.AUDIT_CLONE(taskId));
        reduxStore.dispatch(setSaveStatusClosed());
        return r;
    } catch (error) {
        reduxStore.dispatch(setSaveStatusError());
        return null;
    }
}

const saveTask = async (values) => {
    reduxStore.dispatch(setSaveStatusLoading());
    try {
        const resp = await RestRequestPOST(Endpoints.AUDIT_ADMIN_SAVE(), values);
        if (!!Object.keys(resp.errors).length)
            reduxStore.dispatch(setSaveStatusError(resp.errors[Object.keys(resp.errors)[0]]));
        else
            reduxStore.dispatch(setSaveStatusClosed());
        return resp;
    } catch (error) {
        reduxStore.dispatch(setSaveStatusError());
    }
}

const getHistory = async (taskId) => {
    const resp = await RestRequestGET(Endpoints.AUDIT_HISTORY(taskId));
    reduxStore.dispatch(
        setResource(AUDIT_TASK_HISTORY_RESOURCE, resp)
    )
}

const printHistory = async (taskId) => {
    try {
        await RestRequestBLOB(Endpoints.AUDIT_HISTORY_PRINT(taskId));
    } catch (error) {
    }
}

const clearTask = () => {
    reduxStore.dispatch(
        clearResource(AUDIT_TASK_RESOURCE)
    )
}

const clearList = () => {
    reduxStore.dispatch(
        clearResource(AUDIT_LIST_RESOURCE)
    )
}

const clearHistory = () => {
    reduxStore.dispatch(
        clearResource(AUDIT_TASK_HISTORY_RESOURCE)
    )
}

export default {
    get,
    getTasks,
    deleteTask,
    getHistory,
    printHistory,
    cloneTask,
    clearTask,
    clearList,
    clearHistory,
    AUDIT_LIST_RESOURCE,
    AUDIT_TASK_RESOURCE,
    saveTask
}